module.exports = __webpack_public_path__ + "static/ceora-ford-4d597c83c4cc03662a175b1a0ecc93ab.jpg";